'use client'

import { Message } from '@locmod/intl'
import React from 'react'
import { openModal } from '@locmod/modal'
import cx from 'classnames'
import { Icon } from 'components/ui'
import messages from './messages'
import Nudge from '../Nudge/Nudge'
import { useMedia } from '@/contexts'

const Search: React.FC<{ isVisible: boolean }> = ({ isVisible }) => {
  const { isWideView } = useMedia()

  return (
    <div className="relative">
      <div
        className={cx(
          'h-16 mb:h-10 w-full flex items-center text-accent-grey-400 hover:text-accent-grey-30 py-3 px-6 bg-accent-grey-980 cursor-pointer',
          {
            hidden: isVisible && !isWideView,
          }
        )}
        onClick={() => openModal('SearchModal')}
      >
        <Icon className="size-5 mr-2" name="interface/search" />
        <Message className="text-caption-13" value={messages.title} />
      </div>

      <Nudge />
    </div>
  )
}

export default Search
